import './src/assets/styles/main.css';

// Fired by Gatsby when a new service worker has installed and is ready to take
// over. Deliberately kept free of application logic: the flag covers the case
// where this fires before React has mounted, the event covers the live case.
// Both are consumed by hooks/useServiceWorkerUpdate.
export const onServiceWorkerUpdateReady = () => {
	window.__swUpdateReady = true;
	window.dispatchEvent(new CustomEvent('swupdateready'));
};
